var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeminars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.31 40.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#333530;stroke-miterlimit:10;stroke-width:1.75px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.92,
    y1: 40.67,
    x2: 6.92,
    y2: 29.6
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "29.38 36.31 35.43 28.64 35.43 24.82 18.15 24.82 0.88 24.82 0.88 28.64 6.92 36.31"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 29.38,
    y1: 40.67,
    x2: 29.38,
    y2: 29.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.93,21.94V19.07c0-2.84-5.92-4.81-7.78-4.79s-7.77,2-7.77,4.79v2.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.15,11.41a4.36,4.36,0,0,0,4.32-4.52V5.39a4.32,4.32,0,1,0-8.64,0v1.5A4.37,4.37,0,0,0,18.15,11.41Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "11.24 40.67 11.24 30.56 25.06 30.56 25.06 40.67"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeminars);
export default __webpack_public_path__ + "static/media/Seminars.4182723f1f13e905f53f68a2039ebb7d.svg";
export { ForwardRef as ReactComponent };